import { render } from "./index.vue?vue&type=template&id=6497bdfe"
import script from "./user-popup.ts?vue&type=script&lang=js"
export * from "./user-popup.ts?vue&type=script&lang=js"

import "./user-popup.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script